import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CompleteCurrentAccountDetails } from '@core/interfaces/accounts';
import { HttpClienteService } from '../http-cliente.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private readonly url = environment.apiURL;
  constructor(
    private readonly _http: HttpClienteService,
    ) { }

  getAccounts(data: string, update: boolean){
    const query = `${this.url}/wcl-customer/account-status?code=${data}&update=${update}`
    return this._http.get(query);
  }

  getIntegralAccountStatement(code: string): Observable<CompleteCurrentAccountDetails> {
    const query = `${this.url}/wcl-order/v4/order-balance?code=${code}`;
    return this._http.get(query);
  }
}
